import { RAW_cssValue } from "@classdojo/web/nessie/stylingLib";
import SlideNavigation from "./SlideNavigation";
import { RemoteSlideProps, Slide } from "./types";
import { appMetadataPairshare as pairshareMetadata } from "src/pods/pairshare";
import DisplayPairShareResult from "src/pods/pairshare/components/receiver/PairShareResult";
import RemotePairShareResult from "src/pods/pairshare/components/sender/PairShareResult";
import AppRemoteCard from "src/shared/components/AppRemoteCard";

export const PairShareSlide = (text: string): Slide => {
  return {
    display: () => {
      return <DisplayPairShareResult question={{ text }} />;
    },
    remote: ({ next }: RemoteSlideProps) => {
      return (
        <div sx={{ margin: RAW_cssValue("12px") }}>
          <AppRemoteCard {...pairshareMetadata}>
            <RemotePairShareResult question={{ text }} />
          </AppRemoteCard>

          <SlideNavigation onBack={() => next(-1)} onNext={() => next()} />
        </div>
      );
    },
  };
};
